import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

interface Transaction {
  id: string;
  type: string;
  amount: number;
  currency: string;
  description: string;
  status: string;
  created_at: string;
}

export default function Transactions() {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ amount: '', description: '', type: 'income', currency: 'USD' });

  useEffect(() => {
    loadTransactions();
  }, []);

  async function loadTransactions() {
    try {
      setLoading(true);
      const res = await api.get('/api/transactions');
      setTransactions(res.data || []);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    try {
      await api.post('/api/transactions', {
        ...form,
        amount: parseFloat(form.amount),
      });
      setForm({ amount: '', description: '', type: 'income', currency: 'USD' });
      loadTransactions();
    } catch (err: any) {
      setError(err.message);
    }
  }

  return (
    <div>
      <h1 style={styles.heading}>Transactions</h1>
      {error && <div style={styles.error}>{error}</div>}

      <form onSubmit={handleSubmit} style={styles.form}>
        <select
          value={form.type}
          onChange={(e) => setForm({ ...form, type: e.target.value })}
          style={styles.input}
        >
          <option value="income">Income</option>
          <option value="expense">Expense</option>
          <option value="adjustment">Adjustment</option>
        </select>
        <input
          placeholder="Amount"
          type="number"
          step="0.01"
          value={form.amount}
          onChange={(e) => setForm({ ...form, amount: e.target.value })}
          style={styles.input}
          required
        />
        <input
          placeholder="Description"
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
          style={styles.input}
          required
        />
        <button type="submit" style={styles.button}>Record</button>
      </form>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Date</th>
              <th style={styles.th}>Type</th>
              <th style={styles.th}>Description</th>
              <th style={styles.th}>Amount</th>
              <th style={styles.th}>Status</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((t) => (
              <tr key={t.id}>
                <td style={styles.td}>{new Date(t.created_at).toLocaleDateString()}</td>
                <td style={styles.td}>{t.type}</td>
                <td style={styles.td}>{t.description}</td>
                <td style={styles.td}>{t.currency} {t.amount.toFixed(2)}</td>
                <td style={styles.td}>{t.status}</td>
              </tr>
            ))}
            {transactions.length === 0 && (
              <tr>
                <td colSpan={5} style={{ ...styles.td, textAlign: 'center', color: '#9ca3af' }}>
                  No transactions yet
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  heading: { fontSize: 20, fontWeight: 600, marginBottom: 16 },
  error: { background: '#fef2f2', color: '#991b1b', padding: 10, borderRadius: 8, marginBottom: 12 },
  form: { display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' },
  input: { padding: '8px 10px', fontSize: 14, border: '1px solid #e5e7eb', borderRadius: 6, minWidth: 140 },
  button: { padding: '8px 16px', fontSize: 14, background: '#111827', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 14 },
  th: { textAlign: 'left', padding: '8px 10px', borderBottom: '1px solid #e5e7eb', fontWeight: 600, color: '#6b7280' },
  td: { padding: '8px 10px', borderBottom: '1px solid #f3f4f6' },
};
